import { mapState } from 'vuex';
import passwordSafeModal from '@/views/system/accountManage/passwordSafeModal.vue';
export default {
  components: {
    passwordSafeModal
  },
  data() {
    return {
      url: require('@/assets/vr/IMG_6408.png'),
      visibleModal: false
    };
  },
  computed: {
    ...mapState({
      complexityPopup: state => state.user.complexityPopup
    })
  },
  created() {},
  mounted() {
    /**
     * 密码安全弹框是否显示
     * complexityPopup: 'true' 弹 'false' 不弹
     */

    this.$nextTick(() => {
      console.log(this.complexityPopup, this.$store.state.user.complexityPopup, typeof this.complexityPopup, this.complexityPopup === 'true', '--------complexityPopup imgIndex----------');
      if (this.complexityPopup && this.complexityPopup == 'true') {
        this.visibleModal = true;
        console.log('--------true弹弹弹passwordSafeModal----------');
      } else {
        this.visibleModal = false;
        console.log('false不弹弹弹', this, this.$refs, '--------passwordSafeModal----------');
      }
    });
  }
};